import { HttpClient, HttpContext, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AssetDto } from '@nusign/picflow-backend-types';
import { catchError, firstValueFrom, map, throwError, timer } from 'rxjs';
import { WITH_AUTH } from '../network-interceptor';
import { PICFLOW_CONFIG } from '../picflow-config';
import { StateService } from './state.service';
import { UploadService } from './upload.service';

export interface FromUrlFile {
  url: string;
  name: string;
  size: number;
  source: 'url';
}

@Injectable({
  providedIn: 'root',
})
export class UploadFromUrlService {
  private http = inject(HttpClient);
  private config = inject(PICFLOW_CONFIG);
  private state = inject(StateService);
  private uploadService = inject(UploadService);

  constructor() {
    this.uploadService.alternativeUPloadServices.push({
      source: 'url',
      service: this,
    });
  }

  public async uploadFile(
    file: FromUrlFile,
    galleryId: string,
    sectionId: string,
    position: number,
    assetToReplace?: AssetDto,
    version_name?: string
  ): Promise<AssetDto> {
    return firstValueFrom(
      this.http
        .post<AssetDto>(
          this.config.internalApiUrlBase + '/upload-from-url',
          {
            gallery: galleryId,
            section: sectionId,
            asset_name: file.name,
            position,
            url: file.url,
            asset_to_replace: assetToReplace?.id,
            version_name,
          },
          { context: new HttpContext().set(WITH_AUTH, true) }
        )
        .pipe(
          catchError(err => {
            if (err instanceof HttpErrorResponse) {
              if (err.status === 503) {
                return timer(10_000).pipe(map(() => undefined));
              }
            }
            return throwError(() => err);
          })
        )
    );
  }

  public async uploadFileSimple(file: FromUrlFile, create_url: string): Promise<string> {
    return firstValueFrom(
      this.http
        .post<{ url: string }>(
          this.config.internalApiUrlBase + '/upload-from-url-simple',
          {
            url: file.url,
            create_url,
            tenant_id: this.state.activeTenant$.value.id,
          },
          { context: new HttpContext().set(WITH_AUTH, true) }
        )
        .pipe(map(res => res.url))
    );
  }
}
